import { useDynamicEntityCMSDataContext } from '../../contexts';

import DropdownInput from '../../../inputs/form-inputs/DropdownInput';

export default function JobSchemaMapperInput({ handleChange, value }) {
  const { jobSchema, jobCategories } = useDynamicEntityCMSDataContext();

  const formattedSchemaValues = jobSchema.map((schema) => ({
    value: `{{${schema}}}`,
    label: schema,
  }));

  const formattedCategoryValues = jobCategories.map((category) => ({
    value: `{{category_${category.id}}}`,
    label: `Category: ${category.name}`,
  }));

  const combinedFormattedValues = [...formattedSchemaValues, ...formattedCategoryValues];

  return (
    <div className="d-flex flex-column gap-1">
      <label htmlFor="">Map to a Job Schema</label>
      <DropdownInput
        formattedDropdownValues={combinedFormattedValues}
        value={value}
        onChange={(e) => handleChange(e.value ? e.value : undefined)}
        placeholder="Select a job schema field"
        isClearable
      />
    </div>
  );
}
